import React, { HTMLAttributes, useCallback } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
import store from "store";

import XtSvg from "components/xt/svg";

const { useTranslation } = Hooks;
const { getUrl } = Util;

interface Props extends Omit<HTMLAttributes<HTMLButtonElement>, "title"> {
  isIcon?: boolean;
  currency?: string;
}

const Buy: React.FC<Props> = ({ className, children, isIcon, currency }) => {
  const t = useTranslation();
  // const router = useRouter();
  const { isLogin } = store.user;

  const handleClick = useCallback(() => {
    if (!isLogin) return;
    // location.href = getUrl("/otc/index");
    location.href = getUrl("/wallet/account/common/withdrawal?currency=" + (currency || store.market.name.split("_")[0]));
  }, [isLogin]);

  return (
    <button className={cx("btnTxt", className)} onClick={handleClick}>
      {children || (isIcon ? <XtSvg icon={"deposit"} /> : t("trade.withdraw"))}
    </button>
  );
};

export default observer(Buy);
